module.exports = __webpack_public_path__ + "static/media/close-icon.d4f64154.svg";